import React from 'react';
import PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { keyCode } from '@bingads-webui/keycode';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { Observable } from '@bingads-webui-universal/observable';

export const WithArrowKeys = (ComponentToWrap, staticOptions) => {
  const { interceptTabKey: interceptTabKeyFromStaticOptions = false } = staticOptions || {};
  class HoC extends React.PureComponent {
    static displayName = `WithArrowKeys(${getDisplayName(ComponentToWrap)})`;

    constructor(props) {
      super(props);

      this.observable = new Observable((observer) => {
        this.setData = data => observer.next(data);
      });

      this.onKeyDown = this.onKeyDown.bind(this);

      this.interceptTabKey = interceptTabKeyFromStaticOptions || props.interceptTabKey;
    }

    onKeyDown(e) {
      if (e.keyCode === keyCode.ArrowLeft
          || e.keyCode === keyCode.ArrowRight
          || e.keyCode === keyCode.ArrowUp
          || e.keyCode === keyCode.ArrowDown
          || (e.keyCode === keyCode.Tab && this.interceptTabKey)) {
        e.preventDefault();
        e.stopPropagation();

        this.setData(e.keyCode);
      }
    }

    render() {
      return (
        <div
          role="presentation"
          onKeyDown={this.onKeyDown}
        >
          <ComponentToWrap observable={this.observable} {...this.props} />
        </div>
      );
    }
  }

  HoC.propTypes = {
    interceptTabKey: PropTypes.bool,
  };

  HoC.defaultProps = {
    interceptTabKey: false,
  };

  return hoistNonReactStatics(HoC, ComponentToWrap);
};
